"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiOpciNombreSouscriptionsTrads = void 0;
exports.ESubScpiOpciNombreSouscriptionsTrads = {
    moins_de_3: "Moins de 3",
    plus_de_3: "Plus de 3",
};
